/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import moment from 'moment';
import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  Avatar,
  Box,
  Chip,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  AccessAlarm,
  CheckBox,
  CheckBoxOutlineBlank,
  DoNotDisturb,
  ErrorOutline,
  EventAvailable,
  EventBusy,
  EventRepeat,
  NotificationsActive,
  Schedule,
  Task,
} from '@mui/icons-material';

import {
  generateEventsFromSchedules,
  getScheduleSeriesText,
} from '../../../../../../utils/scheduleHelper';
import {
  grey,
  primary,
} from '../../../../../../utils/brandColors';
import Horse from '../../../../../../components/Horse';

import TagReminderModal from './components/TagReminderModal';

const cellStyle = {
  borderRight: `1px solid ${grey[300]}`,
  maxWidth: 200,
  minWidth: 200,
}
const cellStatus = {
  borderRight: `1px solid ${grey[300]}`,
  width: 160,
};

export const getChipForStatus = (tagReminder) => {
  if (tagReminder.status === 'Incomplete') {
    return (
      <Chip
        color="error"
        // sx={{
        //   width: '100%',
        //   '& .MuiChip-label': { flex: 1 },
        // }}
        // icon={<PriorityHigh />}
        variant="outlined"
        label="Incomplete"
        size="small"
      />
    )
  } if (tagReminder.status === 'Unset') {
    return (
      <Tooltip title="A status cannot be set until there is at least one previous task or one scheduled for the future.">
        <Chip
          // sx={{
          //   width: '100%',
          //   '& .MuiChip-label': { flex: 1 },
          // }}
          // icon={<DoNotDisturb />}
          color="secondary"
          label="No Records"
          size="small"
        />
      </Tooltip>
    )
  } if (tagReminder.status === 'Unscheduled') {
    return (
      <Chip
        // sx={{
        //   width: '100%',
        //   '& .MuiChip-label': { flex: 1 },
        // }}
        // icon={<EventBusy />}
        color="secondary"
        variant="outlined"
        label={tagReminder.status}
        size="small"
      />
    )
  } if (tagReminder.status === 'PastDue') {
    return (
      <Chip
        // sx={{
        //   width: '100%',
        //   '& .MuiChip-label': { flex: 1 },
        // }}
        // icon={<NotificationsActive />}
        color="error"
        label="Past Due"
        size="small"
      />
    )
  } if (tagReminder.status === 'ScheduleMiss') {
    return (
      <Tooltip title="The next scheduled task is well beyond the due date"><Chip
        // sx={{
        //   width: '100%',
        //   '& .MuiChip-label': { flex: 1 },
        // }}
        // icon={<MoreTime />}
        color="warning"
        label="At Risk"
        size="small"
      />
      </Tooltip>
    )
  }
  return (
    <Chip
      // sx={{
      //   width: '100%',
      //   '& .MuiChip-label': { flex: 1 },
      // }}
      // icon={<Check />}
      color="primary"
      label="On Track"
      size="small"
    />
  )
}
const customComparator = (prevProps, nextProps) => JSON.stringify(prevProps.tagReminder) === JSON.stringify(nextProps.tagReminder);

const TagReminderComponent = React.memo(({
  includeHorse,
  tagReminder,
  fullScreen,
  includeTask,
  condensed,
  zIndex,
}) => {
  const [showModal, setShowModal] = React.useState(false);

  React.useEffect(() => {
    setShowModal(false);
  }, [])

  const barnHorsesMap = useSelector((state) => state.barn.barnHorsesMap);
  const barnUsersMap = useSelector((state) => state.barn.barnUsersMap);
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);

  let isSingleOccurrence = null;
  let nextEvents = null;
  let seriesText = null;
  let schedule = null;
  if ((tagReminder.nextSchedule && tagReminder.nextSchedule.nextOccurrenceDate)) {
    schedule = tagReminder.nextSchedule
    isSingleOccurrence = (!schedule.parentSchedule && !!schedule.endDate
      && new Date(schedule.startDate).getTime() === new Date(schedule.endDate).getTime());

    nextEvents = generateEventsFromSchedules([schedule], [], new Date(), moment(schedule.nextOccurrenceDate).add(1, 'days').toDate(), barnUsersMap, selectedBarn.barnMetadata);
    seriesText = getScheduleSeriesText(schedule);
  }

  if (condensed) {
    return (
      <TableRow
        onClick={() => { setShowModal(true); }}
        sx={{
          cursor: 'pointer',
          '&:hover': { background: grey[50] },
        }}
      >
        <TableCell>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            {
              includeHorse && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flex: 1,
                  }}
                >
                  {barnHorsesMap[`${tagReminder.tag.id}`]
                    ? (
                      <Horse
                        barnHorse={barnHorsesMap[`${tagReminder.tag.id}`] && barnHorsesMap[`${tagReminder.tag.id}`][0]}
                        nameMaxWidth={115}
                        showShowName
                        size="sm"
                      />
                    )
                    : (
                      <Typography
                        sx={{ fontSize: '11px' }}
                      >
                        {`Invalid Horse (${tagReminder.tag.name} - ${tagReminder.tag.id}), Contact Support`}
                      </Typography>
                    )}
                </Box>
              )
            }
            {
              includeTask && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flex: 1,
                    gap: 1,
                  }}
                >
                  <IconButton
                    sx={{
                      backgroundColor: (tagReminder.eventTemplateReminder.eventTemplate.eventDataDefaultValues
                        && tagReminder.eventTemplateReminder.eventTemplate.eventDataDefaultValues.calendarDisplayColor)
                        || primary.main,
                    }}
                  ><Task sx={{ color: 'white' }} />
                  </IconButton>
                  <Box
                    sx={{ flex: 1 }}
                  >
                    <Typography fontWeight={500}>{tagReminder.eventTemplateReminder.eventTemplate.name}</Typography>
                    <Typography fontWeight={300}>
                      Due Every {tagReminder.eventTemplateReminder.reminderDays} Days
                    </Typography>
                  </Box>
                </Box>
              )
            }

            <TagReminderStatus
              nextEvents={nextEvents}
              tagReminder={tagReminder}
            />

          </Box>
        </TableCell>

        {
          showModal && (
            <TagReminderModal
              tagReminder={tagReminder}
              open={showModal}
              onClose={(e) => {
                if (e) {
                  e.preventDefault();
                  e.stopPropagation();
                }
                setShowModal(false)
              }}
              zIndex={zIndex}
            />
          )
        }
      </TableRow>
    )
  }

  return (
    <TableRow
      onClick={() => { setShowModal(true); }}
      sx={{
        cursor: 'pointer',
        '&:hover': { background: grey[50] },
      }}
    >
      {
        includeHorse && (
          <TableCell
            sx={{
              ...cellStyle,
              width: (fullScreen && '125px !important') || '210px',
              minWidth: (fullScreen && '125px !important') || '210px',
              maxWidth: (fullScreen && '125px !important') || '210px',
            }}
          >
            {
              barnHorsesMap[`${tagReminder.tag.id}`]
                ? (
                  <Horse
                    size={36}
                    horse={barnHorsesMap[`${tagReminder.tag.id}`] && barnHorsesMap[`${tagReminder.tag.id}`][0].horse}
                    hideShowName
                    flexDirection={!fullScreen
                      ? 'row'
                      : 'column'}
                    textWidth={fullScreen
                      ? 105
                      : 150}
                  />
                )
                : (
                  `Invalid Horse (${tagReminder.tag.name} - ${tagReminder.tag.id}), Contact Support`
                )
            }
          </TableCell>
        )
      }
      {
        includeTask && (

          <TableCell
            sx={{
              ...cellStyle,
              maxWidth: 180,
              minWidth: 180,
              width: 180,
              padding: 0,
            }}
          >
            <ListItem
              dense
              sx={{
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <ListItemAvatar>
                <Avatar
                  sx={{
                    backgroundColor: (tagReminder.eventTemplateReminder.eventTemplate.eventDataDefaultValues
                      && tagReminder.eventTemplateReminder.eventTemplate.eventDataDefaultValues.calendarDisplayColor)
                      || primary.main,
                  }}
                >
                  <Task />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={tagReminder.eventTemplateReminder.eventTemplate.name}
                secondary={`Due Every (${tagReminder.eventTemplateReminder.reminderDays}) Days`}
              />
            </ListItem>

          </TableCell>
        )
      }
      <TableCell sx={{ ...cellStatus }}>
        {getChipForStatus(tagReminder)}
      </TableCell>

      <TableCell
        sx={{
          ...cellStyle,
          py: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mt: 1,
          }}
        >
          <AccessAlarm
            color="secondary"
            sx={{ mr: 0.5 }}
          />
          <Box>
            {tagReminder.status !== 'Unset' && (
              <Typography
                variant="caption"
                sx={{
                  fontSize: 12,
                  lineHeight: '12px',
                }}
                component="div"
              >Reminder Date
              </Typography>
            )}
            {tagReminder.dueDate
              ? moment(tagReminder.dueDate).format('ll')
              : (
                <Tooltip title="Questri won't know or calculate the reminder date unless there is at least one previous completed task. Add this horses historical tasks to calculate this now.">
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >No reminder date
                  </Box>
                </Tooltip>
              )}
          </Box>
        </Box>
      </TableCell>
      <TableCell
        sx={{
          ...cellStyle,
          py: 0,
        }}
      >
        {
          tagReminder.status !== 'Unset'
            ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mt: 1,
                }}
              >
                {!tagReminder.lastEvent && <DoNotDisturb color="secondary" sx={{ mr: 0.5 }} />}
                {tagReminder.lastEvent && tagReminder.lastEvent.completeDate && <CheckBox color="secondary" sx={{ mr: 0.5 }} />}
                {tagReminder.lastEvent && !tagReminder.lastEvent.completeDate && <CheckBoxOutlineBlank color="secondary" sx={{ mr: 0.5 }} />}
                <Box>
                  {tagReminder.lastEvent && (
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: 12,
                        lineHeight: '12px',
                      }}
                      component="div"
                    >
                      {tagReminder.lastEvent.completeDate
                        ? 'Last Completion'
                        : 'Incomplete Since'}
                    </Typography>
                  )}

                  {tagReminder.lastEvent
                    ? (tagReminder.lastEvent.completeDate
                      ? moment(tagReminder.lastEvent.completeDate).format('ll')
                      : moment(tagReminder.lastEvent.startDate).format('ll'))
                    : (
                      <Tooltip title={`This horse does not have any previous tasks created for ${tagReminder.title}.`}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >No previous tasks
                        </Box>
                      </Tooltip>
                    )}
                </Box>
              </Box>
            )
            : (
              <Typography
                variant="caption"
                sx={{
                  fontSize: 12,
                  lineHeight: '12px',
                  mr: 2,
                  fontWeight: 300,
                }}
                component="div"
              >No Records
              </Typography>
            )
        }
      </TableCell>
      <TableCell
        sx={{
          ...cellStyle,
          py: 0,
        }}
      >
        {
          tagReminder.status !== 'Unset'
            ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mt: 1,
                }}
              >
                {
                  (nextEvents && nextEvents.length > 0)
                    ? (
                      <Schedule
                        color="secondary"
                        sx={{ mr: 0.5 }}
                      />
                    )
                    : (
                      <DoNotDisturb
                        color="secondary"
                        sx={{ mr: 0.5 }}
                      />
                    )
                }
                <Box>
                  {(nextEvents && nextEvents.length > 0) && (
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: 12,
                        lineHeight: '12px',
                      }}
                      component="div"
                    >Upcoming Task
                    </Typography>
                  )}
                  {(nextEvents && nextEvents.length > 0)
                    ? (<Tooltip title={(seriesText || (!isSingleOccurrence && schedule.endDate)) && `${(seriesText && `${seriesText} `) || ''}${(!isSingleOccurrence && schedule.endDate && 'Series ending {formatDateOnly(schedule.endDate)') || ''}`}>{moment(nextEvents[0].start).format('ll')}</Tooltip>
                    )
                    : (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          fontWeight: 300,
                        }}
                      >Next task not scheduled
                      </Box>
                    )}
                </Box>
              </Box>
            )
            : (
              <Typography
                variant="caption"
                sx={{
                  fontSize: 12,
                  fontWeight: 300,
                  lineHeight: '12px',
                  mr: 2,
                }}
                component="div"
              >Not Scheduled
              </Typography>
            )
        }
      </TableCell>

      {
        showModal && (
          <TagReminderModal
            tagReminder={tagReminder}
            open={showModal}
            onClose={(e) => {
              if (e) {
                e.preventDefault();
                e.stopPropagation();
              }
              setShowModal(false)
            }}
          />
        )
      }
    </TableRow>
  )
}, customComparator);

TagReminderComponent.propTypes = {
  tagReminder: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool,
  includeHorse: PropTypes.bool,
  includeTask: PropTypes.bool,
  condensed: PropTypes.bool,
  zIndex: PropTypes.number,
};

TagReminderComponent.defaultProps = {
  fullScreen: false,
  includeHorse: true,
  includeTask: false,
  condensed: false,
  zIndex: undefined,
};

export default TagReminderComponent;

export const TagReminderStatus = ({
  nextEvents,
  tagReminder,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      width: '160px',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: 1,
    }}
  >

    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        gap: 0.5,
      }}
    >
      <Box sx={{ display: 'flex' }}><Box sx={{ flex: 1 }} />{getChipForStatus(tagReminder)}</Box>
      {
        tagReminder.status === 'Unset' && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              justifyContent: 'flex-end',
            }}
          >
            <ErrorOutline color="warning" sx={{ fontSize: '16px' }} />
            <Typography
              sx={{ fontSize: '11px' }}
              fontWeight={300}
            >Information Required
            </Typography>
          </Box>
        )
      }
      {
        tagReminder.status === 'Incomplete' && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              justifyContent: 'flex-end',
            }}
          >
            <Schedule color="secondary" sx={{ fontSize: '16px' }} />
            <Typography
              sx={{ fontSize: '11px' }}
              fontWeight={300}
            >
              {tagReminder.lastEvent
                ? (tagReminder.lastEvent.completeDate
                  ? `Since ${moment(tagReminder.lastEvent.completeDate).format('ll')}`
                  : `Since ${moment(tagReminder.lastEvent.startDate).format('ll')}`)
                : (
                  'Since Unknown Date'
                )}
            </Typography>
          </Box>
        )
      }
      {
        tagReminder.status === 'Unscheduled' && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              justifyContent: 'flex-end',
            }}
          >
            <EventRepeat color="warning" sx={{ fontSize: '16px' }} />
            <Typography
              sx={{ fontSize: '11px' }}
              fontWeight={300}
            >{tagReminder.dueDate
              ? `Schedule by ${moment(tagReminder.dueDate).format('ll')}`
              : 'Schedule Task Now'}
            </Typography>
          </Box>
        )
      }
      {
        tagReminder.status === 'PastDue' && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              justifyContent: 'flex-end',
            }}
          >
            <NotificationsActive color="secondary" sx={{ fontSize: '16px' }} />
            <Typography
              sx={{ fontSize: '11px' }}
              fontWeight={300}
            >{tagReminder.dueDate
              ? moment(tagReminder.dueDate).format('ll')
              : 'Information Required'}
            </Typography>
          </Box>
        )
      }
      {
        tagReminder.status === 'ScheduleMiss' && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              justifyContent: 'flex-end',
            }}
          >
            <EventBusy color="secondary" sx={{ fontSize: '16px' }} />
            <Typography
              sx={{ fontSize: '11px' }}
              fontWeight={300}
            >Will Miss Due Date
            </Typography>
          </Box>
        )
      }{
        tagReminder.status === 'Scheduled' && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              justifyContent: 'flex-end',
            }}
          >
            <EventAvailable color="secondary" sx={{ fontSize: '16px' }} />
            <Typography
              sx={{ fontSize: '11px' }}
              fontWeight={300}
            >
              {(nextEvents && nextEvents.length > 0)
                ? `Scheduled ${moment(nextEvents[0].start).format('ll')}`
                : ('Not scheduled')}
            </Typography>
          </Box>
        )
      }
    </Box>
  </Box>
)
